import firebase from "firebase";

export const handleRefOrString = (value: any):string|null => {
  if(!value) return null;
  if(value instanceof firebase.firestore.DocumentReference) return value.path;
  if(typeof value === "string") return value;
  return null;
}

